var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"max-width":"1200px"}},[_c('v-row',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('v-col',{attrs:{"col":"8","md":"8","lg":"8","sm":"8"}},[_c('v-card',{staticStyle:{"min-height":"500px"},attrs:{"elevation":"8"}},[_vm._v(" fsf ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }